import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import beachImage from './images/cherryGrove.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Water Island"
      meta={[
        { name: 'description', content: 'A quiet community on Fire Island with limited access.' },
        { name: 'keywords', content: 'Water Island, Fire Island, Ferries, New York, Long Island, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Water Island">
        <h2>Communities</h2>
        <h1>Water Island</h1>
        <p>Amenities</p>
        <div className="amenities">
          { Amenities.byBeach('Water Island').map(item => (
            <i key={item.text} className={`icon-${item.icon}`} title={item.text} />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="http://www.sayvilleferry.com/">Schedules</Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About Water Island</h1>
          </div>
          <p>
            Water Island is located at the narrowest part of Fire Island, just over a mile to the west of Davis Park.  
            With a mere 50 houses, Water Island is considered one of the quietest communities on Fire Island, with limited ferry and water taxi service.  
          </p>
          <Tip title="Captain's Tip">
            Take a water taxi on Sundays to either the Pines or the Grove to catch a ferry back to Sayville.
          </Tip>
        </div>
        <div className="col-xl-4">
          <Beach image={beachImage} link="/communities/sailors-haven" beach="Water Island" description="With a mere 50 houses, Water Island is considered one of the quietest communities." className="mx-auto" />
        </div>
      </div>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Water Island is available by <Link to="http://www.sayvilleferry.com/">Sayville Ferry</Link> located in Sayville, NY.
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is available to and from Water Island during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
